import { isNil, Nillable } from '@web/utils';
import { Route } from '../enums/route';
import { RouterLinkWithParts } from '../types/router-link-with-parts';
import { RouterLinkParams } from '../types/router-link-params';
import { RouterLink } from '../types/router-link';
import { RouterLinkEntryNotFoundException } from '../exceptions/router-link-entry-not-found.exception';
import { RouteParamsNotFoundExceptions } from '../exceptions/route-params-not-found.exceptions';
import { RouteParamNotFoundException } from '../exceptions/route-param-not-found.exception';
import { RouterPart } from '../types/router-part';
import { RouteParam } from '../enums/route-param';

export abstract class RouteProviderService {
  public abstract routes(): Map<Route, RouterLinkWithParts>;

  public routerLink(
    route: Route,
    params: Nillable<RouterLinkParams> = null,
  ): RouterLink {
    const routerLinkWithParams = this.routes().get(route);

    if (isNil(routerLinkWithParams)) {
      const name = Route[route];

      throw new RouterLinkEntryNotFoundException(name);
    }

    return this.replaceParams(routerLinkWithParams, params);
  }

  private replaceParams(
    routerLinkWithParts: RouterLinkWithParts,
    params: Nillable<RouterLinkParams>,
  ): RouterLink {
    return routerLinkWithParts.map((part) => {
      if (this.isRouteParam(part)) {
        if (isNil(params)) {
          throw new RouteParamsNotFoundExceptions();
        }

        const param = params[part];

        if (isNil(param)) {
          throw new RouteParamNotFoundException(part);
        }

        return param;
      }

      return part;
    });
  }

  private isRouteParam(part: RouterPart): part is RouteParam {
    const availableParams = Object.values(RouteParam) as string[];

    return availableParams.includes(part);
  }
}
